<template>
    <component :is="tag" v-bind="linkProps" @click="handleClick" role="tab"
               :aria-selected="isActive"
               class="tab"
               tabindex="0"
               :class="{'is-active': isActive}"
               :style="style">
        <slot/>
        <span v-if="text" class="text-uppercase">{{ text }}</span>
    </component>
</template>
<script>
import {inject as RegistrableInject} from "../../mixins/Registrable";
    import Toggleable from "../../mixins/Toggleable";
    import Linkable from "../../mixins/Linkable";
    import Colorable from "../../mixins/Colorable";
	import {tabInjection} from "../../types/keys";

    export default {
        name: 'Tab',
        mixins: [RegistrableInject(tabInjection), Toggleable, Linkable, Colorable],

        props: {

            // The unique value to identify the tab item
            // Defaults to the DOM hierarchy index of the parent
            value: {
                type: [String, Number, Boolean],
                default: null
            },

            // The text to display
            text: {
                type: String,
                default: null
            },

            // The height of the tab
            // Required on the tab component to support vertical and horizontal tabs
            height: {
                type: Number,
                default: 42
            },
        },

        computed: {

            tag() {
                if (this.absoluteTo) {
                    return 'a';
                }
                if (this.relativeTo) {
                    return resolveComponent('NuxtLink');
                }

                return 'div';
            },

            style() {
                const style = {
                    height: `${this.height}px`
                };

                if (this.isActive) {
                    if (this.colorHex) {
                        style.color = this.colorHex;
                        style.backgroundColor = `${this.colorHex}0C`; // 5 % opacity
                    }
                }

                return style;
            }
        },

        created() {
            this.injected && this.injected.register(this)
        },

        beforeUnmount() {
            this.injected && this.injected.unregister(this)
        },
    }
</script>
<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app .tabs .tab {
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-width: 42px;
  font-size: 14px;
  padding: 0 16px;
  box-sizing: border-box;
  color: #5e6b6b;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  outline: 0;
  cursor: pointer;
}
.app .tabs .tab:before {
  background-color: currentColor;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.app .tabs .tab.is-active, .app .tabs .tab.is-active:hover {
  color: #008200;
}
.app .tabs .tab:hover {
  color: #7D8484;
}
.app .tabs .tab:hover:before {
  opacity: 0.04;
}
@media (min-width: 0px) and (max-width: 639px) {
  .app .tabs .tab {
    padding: 0 12px;
  }
}
.app .tabs.tabs--center .tab {
  justify-content: center;
}
.app .tabs.is-horizontal .tab {
  justify-content: center;
}
@media (min-width: 1024px) {
  .app .tabs.is-horizontal .tab:first-child {
    padding-left: 24px;
  }
  .app .tabs.is-horizontal .tab:last-child {
    padding-right: 24px;
  }
}
.app .tabs.is-vertical .tab {
  font-size: 15px;
}
@media (min-width: 1024px) {
  .app .tabs.is-vertical .tab {
    padding-left: 24px;
  }
}
@media (min-width: 1024px) {
  .app .tabs.is-vertical.tabs--center .tab {
    padding-left: 16px;
  }
}
</style>